import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/exclaimation.svg'


const _withScopeId = n => (_pushScopeId("data-v-23f2fd2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form_input" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "newPassword",
  class: ""
}, "New password", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "password-list" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createElementVNode("span", null, " Must be at least 8 characters long")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createElementVNode("span", null, " Must contain an uppercase and lowercase (A, a)")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createElementVNode("span", null, " Must contain an number")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode(" Must contain a special character "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("(!, %, @, #)")
    ])
  ])
], -1))
const _hoisted_4 = { class: "form_input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "reEnterPass",
  class: ""
}, "Re-enter new password", -1))
const _hoisted_6 = { class: "card-part" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "common-title" }, "Dont’ have an account?", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_form, {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
      class: "flex gap-4 flex-col",
      ref: "ruleFormRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_v_text_field, {
            "bg-color": "rgba(12, 15, 74, 0.0509803922)",
            variant: "solo",
            class: "input_field password__input",
            rounded: "",
            outlined: "false",
            modelValue: $setup.password,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.password) = $event)),
            rules: $setup.validation.password,
            placeholder: "Enter password",
            "append-inner-icon": $setup.isShowPassword ? 'mdi-eye' : 'mdi-eye-off',
            "onClick:appendInner": _cache[1] || (_cache[1] = () => ($setup.isShowPassword = !$setup.isShowPassword)),
            type: $setup.isShowPassword ? 'text' : 'password'
          }, null, 8, ["modelValue", "rules", "append-inner-icon", "type"])
        ]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_v_text_field, {
            class: "input_field password__input",
            "bg-color": "rgba(12, 15, 74, 0.0509803922)",
            variant: "solo",
            rounded: "",
            outlined: "false",
            modelValue: $setup.confirmPassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.confirmPassword) = $event)),
            rules: $setup.validation.confirmPassword,
            placeholder: "Re-enter password",
            "append-inner-icon": $setup.isShowConfirmPassword ? 'mdi-eye' : 'mdi-eye-off',
            "onClick:appendInner": _cache[3] || (_cache[3] = 
          () => ($setup.isShowConfirmPassword = !$setup.isShowConfirmPassword)
        ),
            type: $setup.isShowConfirmPassword ? 'text' : 'password'
          }, null, 8, ["modelValue", "rules", "append-inner-icon", "type"])
        ]),
        _createVNode(_component_v_btn, {
          class: "button button-orange",
          type: "submit",
          block: "",
          onClick: $setup.onClickSubmitButton
        }, {
          default: _withCtx(() => [
            _createTextVNode("Submit")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("label", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.onClickRegisterButton && $setup.onClickRegisterButton(...args))),
        class: "yellow-text"
      }, [
        _createTextVNode(" Register"),
        _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
      ])
    ])
  ], 64))
}